/** 
 * 計画数設定VO
 */
export class RegistPlanNumModel {
  public orderCode: string = <string>'';       // 受注コード
  public mediumType: string = <string>'';	  // 媒体区分
  public pCode: string = <string>'';           // Ｐコード
  public planNumTotal: string = <string>'';  // 計画数（総数）
  public coopCode1: string = <string>'';     // 生協コード(いばらき)
  public coopCode2: string = <string>'';     // 生協コード(とちぎ)
  public coopCode3: string = <string>'';     // 生協コード(ぐんま)
  public coopCode4: string = <string>'';     // 生協コード(ちば)
  public coopCode5: string = <string>'';     // 生協コード(さいたま)
  public coopCode6: string = <string>'';     // 生協コード(とうきょう)
  public coopCode7: string = <string>'';     // 生協コード(ながの)
  public coopCode8: string = <string>'';     // 生協コード(にいがた)
  public numPi1: string = <string>'';        // 点数PI(いばらき)
  public numPi2: string = <string>'';        // 点数PI(とちぎ)
  public numPi3: string = <string>'';        // 点数PI(ぐんま)
  public numPi4: string = <string>'';        // 点数PI(ちば)
  public numPi5: string = <string>'';        // 点数PI(さいたま)
  public numPi6: string = <string>'';        // 点数PI(とうきょう)
  public numPi7: string = <string>'';        // 点数PI(ながの)
  public numPi8: string = <string>'';        // 点数PI(にいがた)
}
